import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'textoFormateado',
  standalone: false
})
export class FormatTextPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  private decodeHtml(text: string): string {
    const txt = document.createElement('textarea');
    txt.innerHTML = text;
    return txt.value;
  }

  transform(value?: string): SafeHtml {
    if (!value) return '';

    // Decodificación manual de &#13; y &#10; a saltos de línea reales
    const reemplazado = value
      .replace(/&#13;/g, '')
      .replace(/&#10;/g, '<br>')    // o '\n' si no usas innerHTML
      .replace(/&amp;/g, '&')       // Por si hay & codificado
      .replace(/&lt;/g, '<')        // Por si hay < codificado
      .replace(/&gt;/g, '>');       // Por si hay > codificado

    return this.sanitizer.bypassSecurityTrustHtml(reemplazado);
  }
}
